import React, { useCallback, useEffect, useState } from "react";
import api from "../../setupAxios";
import { useDialog } from "../../context/dialogContext";
import { descargar, msgError } from "../../utils";

const VACIA = { id: null, texto: "", tipo: "texto", opciones: "", obligatoria: false, orden: 0, activa: true };
const TIPOS = { texto: "Texto libre", opciones: "Elegir una opción", si_no: "Sí / No" };

export default function TabPreguntas() {
  const { avisar, confirmarPeligro, exito } = useDialog();
  const [lista, setLista] = useState([]);
  const [ed, setEd] = useState(VACIA);

  const cargar = useCallback(async () => {
    try { const { data } = await api.get("/admin/preguntas"); setLista(data.preguntas); } catch (e) { avisar(msgError(e)); }
  }, [avisar]);
  useEffect(() => { cargar(); }, [cargar]);

  const guardar = async () => {
    const cuerpo = { texto: ed.texto, tipo: ed.tipo, obligatoria: ed.obligatoria, orden: +ed.orden || 0, activa: ed.activa,
                     opciones: ed.tipo === "opciones" ? ed.opciones.split("\n").map((s) => s.trim()).filter(Boolean) : [] };
    try {
      if (ed.id) await api.put(`/admin/preguntas/${ed.id}`, cuerpo); else await api.post("/admin/preguntas", cuerpo);
      setEd(VACIA);
      exito("Pregunta guardada");
      cargar();
    } catch (e) { avisar(msgError(e)); }
  };
  const borrar = async (p) => {
    if (!(await confirmarPeligro(`¿Borrar la pregunta «${p.texto}»?\nSi ya tiene respuestas se desactivará para no perderlas.`, { titulo: "Borrar pregunta", boton: "Borrar" }))) return;
    try {
      const { data } = await api.delete(`/admin/preguntas/${p.id}`);
      if (data.desactivada) avisar("Tenía respuestas: se ha desactivado en vez de borrarla.");
      cargar();
    } catch (e) { avisar(msgError(e)); }
  };
  const bajarCsv = async () => { const err = await descargar("/admin/respuestas/export.csv", {}, "respuestas_check_in.csv"); if (err) avisar(err); };

  return (
    <div>
      <div className="card">
        <div className="card-headrow">
          <h3>❓ Preguntas del alumno <span className="count">{lista.length}</span></h3>
          <button className="btn" onClick={bajarCsv}>⬇️ Descargar respuestas (CSV)</button>
        </div>
        <p className="muted">Las ve el alumno en su pantalla y puede editarlas cuando quiera.</p>
        <div className="tablewrap">
          <table className="ci-tabla t-preguntas">
            <thead><tr><th>Orden</th><th>Pregunta</th><th>Tipo</th><th>Obligatoria</th><th>Estado</th><th /></tr></thead>
            <tbody>
              {lista.length === 0 && <tr><td colSpan={6} className="empty">No hay preguntas todavía.</td></tr>}
              {lista.map((p) => (
                <tr key={p.id}>
                  <td className="num-cell">{p.orden}</td>
                  <td className="ci-wrap strong">{p.texto}{p.tipo === "opciones" && <div className="muted">{p.opciones.join(" · ")}</div>}</td>
                  <td>{TIPOS[p.tipo]}</td>
                  <td>{p.obligatoria ? "Sí" : "No"}</td>
                  <td><span className={`badge ${p.activa ? "badge-green" : "badge-gray"}`}>{p.activa ? "Activa" : "Inactiva"}</span></td>
                  <td><div className="acc-cell">
                    <button className="btn btn-mini" onClick={() => setEd({ ...p, opciones: p.opciones.join("\n") })}>✏️</button>
                    <button className="btn btn-mini btn-danger" onClick={() => borrar(p)}>🗑</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h3>{ed.id ? "✏️ Editar pregunta" : "➕ Nueva pregunta"}</h3>
        <div className="field"><label>Texto de la pregunta</label>
          <input value={ed.texto} maxLength={500} onChange={(e) => setEd({ ...ed, texto: e.target.value })} /></div>
        <div className="row">
          <div className="field"><label>Tipo de respuesta</label>
            <select value={ed.tipo} onChange={(e) => setEd({ ...ed, tipo: e.target.value })}>
              {Object.entries(TIPOS).map(([v, t]) => <option key={v} value={v}>{t}</option>)}
            </select></div>
          <div className="field"><label>Orden</label>
            <input type="number" value={ed.orden} onChange={(e) => setEd({ ...ed, orden: e.target.value })} /></div>
        </div>
        {ed.tipo === "opciones" && (
          <div className="field"><label>Opciones (una por línea, mínimo dos)</label>
            <textarea rows={4} value={ed.opciones} onChange={(e) => setEd({ ...ed, opciones: e.target.value })} /></div>
        )}
        <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
          <label style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <input type="checkbox" style={{ width: "auto" }} checked={ed.obligatoria} onChange={(e) => setEd({ ...ed, obligatoria: e.target.checked })} /> Obligatoria</label>
          <label style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <input type="checkbox" style={{ width: "auto" }} checked={ed.activa} onChange={(e) => setEd({ ...ed, activa: e.target.checked })} /> Activa</label>
        </div>
        <div className="modal-actions" style={{ justifyContent: "flex-start" }}>
          {ed.id && <button className="btn" onClick={() => setEd(VACIA)}>Cancelar edición</button>}
          <button className="btn btn-primary" disabled={!ed.texto.trim()} onClick={guardar}>{ed.id ? "Guardar cambios" : "Añadir pregunta"}</button>
        </div>
      </div>
    </div>
  );
}
